/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import Loader from '../../../components/Loader/Loader';
import {checkIfHasPermissions} from '../../../components/Menu/Utils/commonFunctions';
import Tabs from '../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../constants/permissionsEnum';
import TranslatedText from '../../../libraries/I18N/TranslatedText';
import {APITypeEnum} from '../../../services/interface/tableAPIType';
import countryJSON from '../../../services/modules/JSON/country';
import statesJSON from '../../../services/modules/JSON/statesJSON';
import facilityDetailsAPI from '../../../services/modules/OM/facilityDetails';
import {checkCurrentYearOrBelow} from '../../../utils/commonFunctions';
// import {yearSelect} from '../../../utils/FormUtils/yearSelect';
import YearAndCountryFilter from '../components/YearAndCountryFilter';

import ElectricityTab from './utils/electricity/ElectricityTab';
import FuelTab from './utils/fuel/FuelTabs';
import WasteTab from './utils/waste/WasteTab';
import WaterTab from './utils/water/WaterTab';

const UtilityTab: React.FC = () => {
  const [selectedYear, setSelectedYear] = useState('');
  const [selCountry, setSelCountry] = useState<number | undefined>(undefined);
  const [selState, setSelState] = useState<number | undefined>(undefined);
  const [searchParam, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isTabLoading, setIsTabLoading] = useState(true);
  const utilityTabs = [
    {
      id: 'nzmFuel',
      name: <TranslatedText translationKey="Fuel" />,
      component: (
        <FuelTab
          selCountry={selCountry}
          selState={selState}
          selectedYear={selectedYear}
          setTabLoading={setIsTabLoading}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilitiesFuel)
    },
    {
      id: 'nzmElectricity',
      name: <TranslatedText translationKey="Electricity" />,
      component: (
        <ElectricityTab
          selCountry={selCountry}
          selState={selState}
          selectedYear={selectedYear}
          setTabLoading={setIsTabLoading}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilitiesElectricity)
    },
    {
      id: 'nzmWater',
      name: <TranslatedText translationKey="Water" />,
      component: (
        <WaterTab
          selCountry={selCountry}
          selState={selState}
          selectedYear={selectedYear}
          setTabLoading={setIsTabLoading}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilitiesWater)
    },
    {
      id: 'nzmWaste',
      name: <TranslatedText translationKey="Waste" />,
      component: (
        <WasteTab
          selCountry={selCountry}
          selState={selState}
          selectedYear={selectedYear}
          setTabLoading={setIsTabLoading}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilitiesWaste)
    }
  ].filter((item) => !item.hidden);

  // const firstYear = yearSelect();
  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    Promise.all([
      countryJSON(),
      statesJSON(),
      facilityDetailsAPI(APITypeEnum.GET_ALL, false)
    ])
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <div className="utilityMainFlex">
      {selectedYear ? (
        <YearAndCountryFilter
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          setSelCountry={setSelCountry}
          setSelState={setSelState}
          selState={selState}
          selCountry={selCountry}
          isDisabled={isTabLoading}
        />
      ) : (
        <></>
      )}

      <Tabs array={utilityTabs} navBoxContent type="card" />
    </div>
  );
};

export default UtilityTab;
